import Repository from './Repository'

export default {

  requestTokenSMS (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/token_sms', params
    )
  },
  claimWorkplaceURL (id, params) {
    return Repository.public().post(
      'claim/user/' + id + '/wp_url', params
    )
  }

}
